// noinspection JSUnusedGlobalSymbols -- imported via d.ts
const GRID_CUSTOM_COLUMN_TYPES = Object.freeze({
	ROW_PICKER: 'custom-type-row-picker',
});

export {GRID_CUSTOM_COLUMN_TYPES};
